import { useMutation } from "react-query";
import { updateAttribute } from "components/attributes/lib/attribute-data";

export const useUpdateAttribute = () => {
    return useMutation((payload) => updateAttribute(payload));
};
